module.exports = __webpack_public_path__ + "img/two.ea2eed1b.png";